/**
 * Custom chain definitions for V7.
 *
 * Browser-safe: no `process.env.*` access. Both server-side
 * (`packages/core/src/contracts/client.ts`) and frontend
 * (`apps/web/src/lib/onchain.ts`) callers pass their own RPC URL.
 *
 * Why not reuse viem's `base` from `viem/chains` for the Tenderly
 * Virtual TestNet? viem's `base` reports chainId 8453, but the
 * Tenderly fork's chainId is 9998453 (per `deployments/tenderly.json`).
 * The mismatch is silent for most read paths because Multicall3
 * happens to be deployed at the same address on the fork. It becomes
 * load-bearing the moment we sign EIP-712: `domain.chainId` is hashed
 * into the signature; signing with 8453 against the 9998453 fork
 * produces a signature invalid on either chain.
 *
 * See `docs/architecture/VIEM_BEST_PRACTICES.md` §3.7 for the audit.
 */

import { defineChain } from 'viem';

export const TENDERLY_BASE_FORK_ID = 9998453;

const MULTICALL3_ADDRESS = '0xcA11bde05977b3631167028862bE2a173976CA11' as const;

export function tenderlyBaseFork(rpcUrl: string) {
  return defineChain({
    id: TENDERLY_BASE_FORK_ID,
    name: 'Tenderly Base Fork',
    nativeCurrency: { decimals: 18, name: 'Ether', symbol: 'ETH' },
    rpcUrls: {
      default: { http: [rpcUrl] },
    },
    blockExplorers: {
      default: { name: 'Tenderly Dashboard', url: 'https://dashboard.tenderly.co' },
    },
    contracts: {
      multicall3: {
        address: MULTICALL3_ADDRESS,
        blockCreated: 5882,
      },
    },
  });
}
